import axios from 'axios';
import { getPortalSupportedLocalization } from '@next/shared';
import { useQuery } from '@tanstack/react-query';
import { useLocalizationContext } from 'shared/lib/localization';
import { LegalDocumentResponseModel } from '@next/backend-client';

export const useLegalDocumentsQuery = () => {
    const { language } = useLocalizationContext();

    const { data, isFetching, isError } = useQuery({
        queryKey: ['legal-documents', language],
        queryFn: async (): Promise<LegalDocumentResponseModel[]> => {
            const response = await axios.get(`${process.env.PUBLIC_URL}/legal-documents`, {
                params: { locale: getPortalSupportedLocalization(language) },
            });

            return response.data;
        },
        enabled: !!language,
    });

    const modifiedDocs: LegalDocumentResponseModel[] | undefined = data?.map(doc => ({
        ...doc,
        Text: doc.Text.replaceAll('<a', '<a target="_blank"'),
    }));

    return { documents: modifiedDocs, isFetching, isError };
};
